import React from "react";
import { Alert, Box, CheckboxField, TextField } from "@curves/ui-base";
import { PaidList } from "@icoach/documents/components";
import { Grid } from "@mui/material";
import { PaidListLayout, PaidListTotalGroup } from "@icoach/documents/components/PaidList";
import { convertBooleanToOptionArray, formatCurrencyFn, getErrorModuleStatus } from "@util/utils";
import { useMembershipQuitFormContext } from "@icoach/documents/membership/quit/MembershipQuitFormContext";

const MembershipQuitSettlementSection104 = () => {
	const { formData, formRef, validationErrors, updateField, isReadOnly } = useMembershipQuitFormContext();

	return (
		<Grid item xs={6}>
			<PaidListLayout className="mb-3" title="差額費用計算">
				<PaidList.PaidListGroup>
					<PaidList.PaidListItem label="月平均差額">
						<TextField
							ref={el => (formRef.current.avgMonthFeeDiff = el)}
							key={formData?.avgMonthFeeDiff}
							defaultValue={formData?.avgMonthFeeDiff}
							onChangeNative={e => updateField("avgMonthFeeDiff", e.target.value)}
							{...getErrorModuleStatus(validationErrors, "avgMonthFeeDiff")}
							maskType="MONEY"
							disabled
						/>
					</PaidList.PaidListItem>
					<PaidList.PaidListItem>
						<Box className="fee-tip">
							(月費 <span className="text-info">{formatCurrencyFn(formData?.monthlyFee, { symbol: "$" })}</span> - 月平均價格{" "}
							<span className="text-info">{formatCurrencyFn(formData?.avgMonthFee, { symbol: "$" })}</span>) x 已使用月數{" "}
							<span className="text-info">{formData?.usedTotalMonth}</span>
						</Box>
					</PaidList.PaidListItem>
					<PaidList.PaidListItem label="終止手續費">
						<TextField
							ref={el => (formRef.current.quitFee = el)}
							key={formData?.quitFee}
							defaultValue={formData?.quitFee}
							onChangeNative={e => updateField("quitFee", e.target.value)}
							{...getErrorModuleStatus(validationErrors, "quitFee")}
							maskType="MONEY"
							disabled
						/>
					</PaidList.PaidListItem>
					<PaidList.PaidListItem>
						<Box className="fee-tip">
							月平均價格 <span className="text-info">{formatCurrencyFn(formData?.avgMonthFee, { symbol: "$" })}</span> x 未履約月數{" "}
							<span className="text-info">{formData?.unusedTotalMonth}</span> x <span className="text-info">20%</span>
						</Box>
					</PaidList.PaidListItem>
				</PaidList.PaidListGroup>
				<PaidList.PaidListGroup>
					<PaidList.PaidListItem label="終止費用總計" className={"font-weight-bold"}>
						<strong className="paid-list-cell">{formatCurrencyFn(formData?.finalRefund)}</strong>
					</PaidList.PaidListItem>
					<PaidList.PaidListItem label="" className={"mt-0"}>
						<CheckboxField
							ref={el => (formRef.current.isFreeQuitFee = el)}
							key={convertBooleanToOptionArray(formData?.isFreeQuitFee)}
							defaultValue={convertBooleanToOptionArray(formData?.isFreeQuitFee)}
							onChange={e => updateField("isFreeQuitFee", e.target.checked)}
							{...getErrorModuleStatus(validationErrors, "isFreeQuitFee")}
						>
							<CheckboxField.Checkbox label={"免收終止費用"} value={1} />
						</CheckboxField>
					</PaidList.PaidListItem>
					<PaidList.PaidListItem className={"mt-0"}>
						<Box className="fee-tip">
							最多向會員收取 <span className="text-info">{formatCurrencyFn(3800, { symbol: "$" })}</span>
						</Box>
					</PaidList.PaidListItem>
					<PaidList.PaidListItem label="已扣月費退費">
						<TextField defaultValue={(formData?.withholdingRefund + formData?.withExtensionRefund + formData?.withSuspendRefund) * -1} maskType="MONEY" disabled />
					</PaidList.PaidListItem>
					<PaidList.PaidListItem>
						<Box className="fee-tip">
							當月已扣月費退回 <span className="text-info">{formatCurrencyFn(formData?.withholdingRefund, { symbol: "$" })}</span> + 已扣延展退費{" "}
							<span className="text-info">{formatCurrencyFn(formData?.withExtensionRefund + formData?.withSuspendRefund, { symbol: "$" })}</span>
						</Box>
					</PaidList.PaidListItem>
					<PaidList.PaidListItem label="工本費">
						<TextField
							ref={el => (formRef.current.processingFee = el)}
							key={formData?.processingFee}
							defaultValue={formData?.processingFee}
							onChangeNative={e => updateField("processingFee", e.target.value)}
							{...getErrorModuleStatus(validationErrors, "processingFee")}
							maskType="MONEY"
							readOnly={isReadOnly}
						/>
					</PaidList.PaidListItem>
				</PaidList.PaidListGroup>
				{formData?.totalPrice < 1 ? (
					<PaidListTotalGroup total={formData?.totalPrice}>
						{formData?.totalPrice < 0 && (
							<React.Fragment>
								<Alert className={"mt-2"} severity={"info"} variant={"filled"} color={"error"}>
									此筆退款將合併於批次扣款刷退中一併退還予會員
								</Alert>
								<CheckboxField
									key={formData?.processingFee}
									ref={el => (formRef.current.isRefundCash = el)}
									defaultValue={convertBooleanToOptionArray(formData?.isRefundCash)}
									onChange={e => updateField("isRefundCash", e.target.checked)}
									{...getErrorModuleStatus(validationErrors, "isFreeQuitFee")}
									readOnly={isReadOnly}
								>
									<CheckboxField.Checkbox label="現場現金退款：若會員使用既存月費及ACH付款發票會直接折讓，若信用卡扣款則發票折讓但不會刷退" value={1} />
								</CheckboxField>
							</React.Fragment>
						)}
					</PaidListTotalGroup>
				) : (
					<PaidList.PaidListGroup>
						<PaidList.PaidListItem label="合計" className={"font-weight-bold"}>
							<strong className="paid-list-cell text-primary">{formatCurrencyFn(formData?.totalPrice)}</strong>
						</PaidList.PaidListItem>
						<PaidList.PaidListItem label="現金收款金額">
							<TextField
								ref={el => (formRef.current.cashPaymentAmount = el)}
								key={formData?.cashPaymentAmount}
								defaultValue={formData?.cashPaymentAmount}
								onChangeNative={e => updateField("cashPaymentAmount", e.target.value)}
								{...getErrorModuleStatus(validationErrors, "cashPaymentAmount")}
								maskType={"MONEY"}
								inputProps={{ min: 0 }}
								readOnly={isReadOnly}
								required
							/>
						</PaidList.PaidListItem>
						<PaidList.PaidListItem label="信用卡收款金額">
							<TextField
								ref={el => (formRef.current.cardPaymentAmount = el)}
								key={formData?.cardPaymentAmount}
								defaultValue={formData?.cardPaymentAmount}
								onChangeNative={e => updateField("cardPaymentAmount", e.target.value)}
								{...getErrorModuleStatus(validationErrors, "cardPaymentAmount")}
								maskType={"MONEY"}
								inputProps={{ min: 0 }}
								readOnly={isReadOnly}
								required
							/>
						</PaidList.PaidListItem>
					</PaidList.PaidListGroup>
				)}
			</PaidListLayout>
		</Grid>
	);
};

export default MembershipQuitSettlementSection104;
